export function isValidHex(hex: string) {
  return hex.match(/^([0-9A-F]{3}){1,2}$/i);
}

export function ensureColorHasHashtag(color: string) {
  return "#" + color.replace(/#/g, "");
}
